import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import Button from '@mui/material/Button';
import { createGetSharedDeviceIdsOutbound, createShowRakeTotalsOutbound, createShowTestEmailLogOutbound, createSuperAdminListModestPlayersOutbound, createSuperAdminRequestConfigSettingsOutbound } from '../../api/outbound/commonOutbounds';
import { GoToPathButtonContainer } from '../../components/goToPathButtonContainer';
import { SUPER_ADMIN_IDS } from '../../constants/constants';
import { useCloseSocket, useSocketSend } from '../../context/webSocket/webSocketContext';
import { openSuperAdminAccount } from '../../redux/actions/commonReduxActions';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { runStressTest } from '../../utils/stressTestUtils';
import { isLocalhostEnvironment } from '../../utils/utils';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 15px;
`;
export const SuperAdminDrawerButtonGroupContainer = ({ closeDrawer }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const closeSocket = useCloseSocket();
    const isAdmin = useAppSelector((state) => state.selfData.isAdmin);
    // TODO: Determine 'super admin' status a bit more conclusively.
    const isSuperAdmin = useAppSelector((state) => state.selfData.isAdmin && state.selfData.id !== undefined && SUPER_ADMIN_IDS.includes(state.selfData.id));
    const isLobby = useAppSelector((state) => state.scene.roomSceneType === 'lobby');
    if (!isSuperAdmin && !isLocalhostEnvironment()) {
        return null;
    }
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(Button, { onClick: () => {
                    dispatch(openSuperAdminAccount());
                    closeDrawer();
                }, startIcon: _jsx(LaunchRoundedIcon, {}), variant: 'outlined', size: 'small', disabled: isLocalhostEnvironment(), children: "Super Admin Account" }), _jsx(Button, { onClick: () => {
                    dispatch(addMessageBox({ type: 'dev-tools' }));
                    closeDrawer();
                }, variant: 'outlined', size: 'small', children: "Dev Tools" }), _jsx(Button, { onClick: () => {
                    socketSend(createSuperAdminRequestConfigSettingsOutbound());
                    closeDrawer();
                }, variant: 'outlined', size: 'small', disabled: !isAdmin, children: "Config Settings" }), _jsx(Button, { onClick: () => {
                    socketSend(createGetSharedDeviceIdsOutbound());
                    closeDrawer();
                }, variant: 'outlined', size: 'small', children: "Shared Device IDs" }), _jsx(Button, { onClick: () => {
                    socketSend(createSuperAdminListModestPlayersOutbound());
                    closeDrawer();
                }, variant: 'outlined', size: 'small', disabled: !isAdmin, children: "Top Modest Players" }), _jsx(Button, { onClick: () => {
                    socketSend(createShowRakeTotalsOutbound());
                    closeDrawer();
                }, variant: 'outlined', size: 'small', children: "Rake Totals" }), _jsx(Button, { onClick: () => {
                    dispatch(addMessageBox({ type: 'mtt-tools' }));
                    closeDrawer();
                }, variant: 'outlined', size: 'small', disabled: !isLobby, children: "MTT Tools" }), isLocalhostEnvironment() && (_jsx(Button, { onClick: () => {
                    socketSend(createShowTestEmailLogOutbound());
                    closeDrawer();
                }, variant: 'outlined', size: 'small', children: "Test Email Log" })), _jsx(Button, { onClick: () => {
                    closeDrawer();
                    runStressTest();
                }, variant: 'outlined', size: 'small', disabled: !isLobby, children: "Stress Test" }), _jsx(Button, { onClick: () => {
                    closeDrawer();
                    closeSocket();
                }, variant: 'outlined', size: 'small', children: "Disconnect (Client)" }), _jsx(GoToPathButtonContainer, { isSuperAdminSection: true, closeDrawer: closeDrawer })] }));
};
